import { stateAbbreviation } from "../../utilities/charts/state_abbreviation_map";
import SimpleUsStateMapChartControllerBase from "./simple_us_state_map_chart_controller_base";

const NO_DATA_COLOR = "#d2d6dc";
// Light-to-dark teal ramp derived from the chart palette (colors.js teal family)
const RAMP = ["#E3F2F5", "#A9DAE2", "#7FC7D4", "#54B5C6", "#2C7481"];

const compactNumber = new Intl.NumberFormat("en", {
  notation: "compact",
  maximumFractionDigits: 1,
});

// Continuous-scale state map for an enrollment metric. Chart data (from
// PayerProfile::MetricBreakdown#chart_data):
//   { states: { "IN": 600 , ... }, label: "Total Medicaid", max: 600 }
export default class extends SimpleUsStateMapChartControllerBase {
  metricValue(abbreviation) {
    return this.params.states[abbreviation];
  }

  bucketIndex(value) {
    if (!this.params.max) return 0;

    return Math.min(RAMP.length - 1, Math.floor((value / this.params.max) * RAMP.length));
  }

  valueForState(abbreviation) {
    return this.metricValue(abbreviation) || 0;
  }

  colorForState(abbreviation) {
    const value = this.metricValue(abbreviation);

    if (value === undefined || value === null) return NO_DATA_COLOR;

    return RAMP[this.bucketIndex(value)];
  }

  legendLabels(chart) {
    const bucketSize = (this.params.max || 0) / RAMP.length;

    const buckets = RAMP.map((color, i) => ({
      text: `${compactNumber.format(i * bucketSize)} – ${compactNumber.format(
        (i + 1) * bucketSize,
      )}`,
      fillStyle: color,
      pointStyle: "rect",
      fontColor: chart.legend.options.labels.color,
    }));

    return [
      ...buckets,
      {
        text: "No data",
        fillStyle: NO_DATA_COLOR,
        pointStyle: "rect",
        fontColor: chart.legend.options.labels.color,
      },
    ];
  }

  tooltipLabel(item) {
    const value = this.metricValue(stateAbbreviation(item.raw.feature));

    if (value === undefined || value === null) return "No data";

    return `${this.params.label}: ${value.toLocaleString()}`;
  }
}
